import React from "react";
import { Link } from "react-router-dom";

import NavMenuDesktop from "../common/NavMenuDesktop";
import NavMenuMobile from "../common/NavMenuMobile";

import "../../assests/css/RefundPolicy.css";

function RefundPolicy() {
    return (
        <>
            {/* ================= HEADER / NAVIGATION ================= */}

            <NavMenuDesktop />
            <NavMenuMobile />


            {/* ================= REFUND POLICY ================= */}

            <section className="refund-policy">


                {/* ================= POLICY HEADER ================= */}

                <div className="refund-header">

                    <Link
                        to="/"
                        className="refund-home"
                    >
                        <i className="fa fa-arrow-left"></i>
                        <span>Back to Home</span>
                    </Link>


                    <span className="refund-label">
                        PRIME LUXURY
                    </span>


                    <h1>
                        Refund Policy
                    </h1>


                    <p>
                        This Refund Policy explains the terms and conditions
                        applicable to cancellations, refunds and payments for
                        services provided by Prime Luxury Passenger Transport LLC.
                    </p>


                    <span className="refund-date">
                        Last Updated: September 11, 2026
                    </span>

                </div>



                {/* ================= CONTENT ================= */}

                <div className="refund-container">


                    {/* ================= 01 INTRODUCTION ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            01
                        </div>

                        <div className="refund-content">

                            <h2>
                                Introduction
                            </h2>

                            <p>
                                Prime Luxury Passenger Transport LLC
                                ("Prime Luxury", "we", "our" or "us")
                                provides chauffeur, limousine, airport
                                transfer, passenger transportation and related
                                services in Dubai, UAE.
                            </p>

                            <p>
                                This Refund Policy explains how cancellations,
                                booking changes and refunds are handled for
                                services booked through our website, WhatsApp,
                                email, telephone or other approved booking
                                channels.
                            </p>

                        </div>

                    </div>



                    {/* ================= 02 BOOKING PAYMENTS ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            02
                        </div>

                        <div className="refund-content">

                            <h2>
                                Booking Payments
                            </h2>

                            <p>
                                Depending on the service and booking
                                requirements, Prime Luxury may require full
                                or partial payment before the service is
                                provided.
                            </p>

                            <p>
                                Payment requirements, applicable charges and
                                cancellation conditions may be communicated
                                to the customer during the booking process.
                            </p>

                        </div>

                    </div>



                    {/* ================= 03 CANCELLATION ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            03
                        </div>

                        <div className="refund-content">

                            <h2>
                                Cancellation Policy
                            </h2>

                            <p>
                                Customers may request cancellation of a
                                booking by contacting Prime Luxury as soon
                                as possible.
                            </p>

                            <p>
                                Refund eligibility may depend on the type of
                                service, the time remaining before the
                                scheduled pickup and whether the vehicle or
                                chauffeur has already been dispatched.
                            </p>

                            <ul>

                                <li>
                                    Cancellations made sufficiently in advance
                                    may be eligible for a full or partial
                                    refund.
                                </li>

                                <li>
                                    Late cancellations may be subject to
                                    cancellation charges.
                                </li>

                                <li>
                                    Cancellations after vehicle or chauffeur
                                    dispatch may not qualify for a full refund.
                                </li>

                                <li>
                                    No-show bookings may not be eligible for
                                    a refund.
                                </li>

                            </ul>

                        </div>

                    </div>



                    {/* ================= 04 AIRPORT TRANSFERS ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            04
                        </div>

                        <div className="refund-content">

                            <h2>
                                Airport Transfer Cancellations
                            </h2>

                            <p>
                                Airport transfer bookings may require
                                additional operational arrangements, including
                                vehicle allocation and chauffeur scheduling.
                            </p>

                            <p>
                                Customers should notify Prime Luxury as early
                                as possible if a flight, pickup time or
                                transfer requirement changes.
                            </p>

                            <p>
                                Refunds for airport transfers may depend on
                                the cancellation time and whether the
                                chauffeur or vehicle has already been
                                assigned or dispatched.
                            </p>

                        </div>

                    </div>



                    {/* ================= 05 NO SHOW ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            05
                        </div>

                        <div className="refund-content">

                            <h2>
                                No-Show Policy
                            </h2>

                            <p>
                                A booking may be considered a no-show when
                                the customer does not appear at the agreed
                                pickup location within the applicable waiting
                                period and cannot be reached using the contact
                                information provided during booking.
                            </p>

                            <p>
                                No-show bookings may be charged in full and
                                may not be eligible for a refund.
                            </p>

                        </div>

                    </div>



                    {/* ================= 06 FLIGHT CHANGES ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            06
                        </div>

                        <div className="refund-content">

                            <h2>
                                Flight Delays and Changes
                            </h2>

                            <p>
                                Customers should provide accurate flight
                                information when making an airport transfer
                                booking.
                            </p>

                            <p>
                                Where a flight is delayed or rescheduled,
                                Prime Luxury will make reasonable efforts to
                                accommodate the revised pickup time, subject
                                to vehicle and chauffeur availability.
                            </p>

                            <p>
                                Additional waiting time or changes outside
                                the original booking may result in additional
                                charges.
                            </p>

                        </div>

                    </div>



                    {/* ================= 07 SERVICE CANCELLATION ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            07
                        </div>

                        <div className="refund-content">

                            <h2>
                                Cancellation by Prime Luxury
                            </h2>

                            <p>
                                In exceptional circumstances, Prime Luxury
                                may need to cancel or modify a booking due
                                to operational, safety, regulatory, vehicle
                                availability or other unforeseen reasons.
                            </p>

                            <p>
                                Where Prime Luxury cancels a prepaid service
                                and cannot provide a suitable alternative,
                                the customer may be eligible for a refund of
                                the amount paid for the affected service.
                            </p>

                        </div>

                    </div>



                    {/* ================= 08 REFUND PROCESS ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            08
                        </div>

                        <div className="refund-content">

                            <h2>
                                Refund Process
                            </h2>

                            <p>
                                Approved refunds will normally be processed
                                using the original payment method where
                                practical and permitted by the applicable
                                payment provider.
                            </p>

                            <p>
                                The time required for a refund to appear in
                                the customer's account may depend on the
                                customer's bank, card issuer or payment
                                service provider.
                            </p>

                        </div>

                    </div>



                    {/* ================= 09 NON REFUNDABLE ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            09
                        </div>

                        <div className="refund-content">

                            <h2>
                                Non-Refundable Charges
                            </h2>

                            <p>
                                Certain charges may be non-refundable,
                                including applicable cancellation charges,
                                waiting-time charges, additional service
                                charges or costs already incurred in
                                connection with a booking.
                            </p>

                            <p>
                                Any applicable non-refundable charges will be
                                communicated to the customer where applicable.
                            </p>

                        </div>

                    </div>



                    {/* ================= 10 BOOKING CHANGES ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            10
                        </div>

                        <div className="refund-content">

                            <h2>
                                Booking Changes
                            </h2>

                            <p>
                                Customers may request changes to pickup
                                locations, dates, times, passenger numbers or
                                vehicle requirements.
                            </p>

                            <p>
                                Changes are subject to availability and may
                                result in a revised price or additional
                                charges.
                            </p>

                        </div>

                    </div>



                    {/* ================= 11 DISPUTES ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            11
                        </div>

                        <div className="refund-content">

                            <h2>
                                Refund Disputes
                            </h2>

                            <p>
                                If you believe that a refund has not been
                                processed correctly, please contact Prime
                                Luxury with your booking reference and
                                relevant payment information.
                            </p>

                            <p>
                                We will review the booking and payment records
                                and respond to the request as soon as
                                reasonably possible.
                            </p>

                        </div>

                    </div>



                    {/* ================= 12 POLICY CHANGES ================= */}

                    <div className="refund-section">

                        <div className="refund-number">
                            12
                        </div>

                        <div className="refund-content">

                            <h2>
                                Changes to This Refund Policy
                            </h2>

                            <p>
                                Prime Luxury may update this Refund Policy
                                from time to time to reflect changes in our
                                services, business practices or applicable
                                legal requirements.
                            </p>

                            <p>
                                Any changes will be published on this page
                                with an updated "Last Updated" date.
                            </p>

                        </div>

                    </div>



                    {/* ================= CONTACT ================= */}

                    <div className="refund-contact">


                        <div className="refund-contact-icon">

                            <i className="fa fa-credit-card"></i>

                        </div>


                        <div>

                            <span>
                                QUESTIONS ABOUT REFUNDS?
                            </span>


                            <h2>
                                Contact Prime Luxury
                            </h2>


                            <p>
                                If you have questions about a cancellation,
                                payment or refund, please contact our team.
                            </p>


                            <div className="refund-contact-links">


                                {/* PHONE */}

                                <a
                                    href="tel:+971501011783"
                                >
                                    <i className="fa fa-phone"></i>

                                    <span>
                                        +971 50 101 1783
                                    </span>
                                </a>



                                {/* WHATSAPP */}

                                <a
                                    href="https://wa.me/971501011783"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-whatsapp"></i>

                                    <span>
                                        WhatsApp Us
                                    </span>
                                </a>



                                {/* EMAIL */}

                                <a
                                    href="mailto:info@dxblimo.com"
                                >
                                    <i className="fa fa-envelope"></i>

                                    <span>
                                        booking@dxblimo.com
                                    </span>
                                </a>


                            </div>


                        </div>


                    </div>


                </div>


            </section>
        </>
    );
}

export default RefundPolicy;